import { render, staticRenderFns } from "./VCA_Gameplay.vue?vue&type=template&id=40d6fe53&scoped=true&"
import script from "./VCA_Gameplay.vue?vue&type=script&lang=ts&"
export * from "./VCA_Gameplay.vue?vue&type=script&lang=ts&"
import style0 from "./VCA_Gameplay.vue?vue&type=style&index=0&id=40d6fe53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d6fe53",
  null
  
)

export default component.exports